import { CarMakesResponse } from '../types';
import ApiClient from './apiClient';

export const getCarMakes = async (): Promise<CarMakesResponse> => {
  return await ApiClient.get<CarMakesResponse>(`car-model`, { queryParams: { onlyActive: true } });
};
